export enum Platform {
  Unknown,
  Android,
  IOS,
  Other
}
